export type CompletionVerdict = "count" | "already-counted" | "none";

/**
 * Counts at most one completion per page session. A completion happens when
 * playback ends, or when the playhead crosses 90% of the duration through
 * genuine forward playback (small natural increments). Landing at or past 90%
 * via a deep link or a manual seek never counts on its own.
 */
export class CompletionTracker {
  private maxForwardSeconds = 0;
  private counted = false;

  constructor(private readonly durationSeconds: number) {}

  observe(previousSeconds: number, nextSeconds: number, ended = false): CompletionVerdict {
    const delta = nextSeconds - previousSeconds;
    if (Number.isFinite(delta) && delta > 0 && delta < 3) {
      this.maxForwardSeconds = Math.max(this.maxForwardSeconds, nextSeconds);
    }
    if (this.counted) return "already-counted";
    const duration = Number(this.durationSeconds);
    const crossedThroughPlayback = duration > 0 && this.maxForwardSeconds >= duration * 0.9;
    if (ended || crossedThroughPlayback) {
      this.counted = true;
      return "count";
    }
    return "none";
  }
}
